<template>
  <div :class="$style.base">
    <BaseCard :heading="filters.capitalize(t('global.items.note', 2))">
      <CreateNoteModal
        v-if="showNoteModal"
        :currentNote="stockOrder.notes || undefined"
        @submit="handleNoteUpdate($event, 'edit')"
        @close="showNoteModal = false"
      />
      <div :class="$style.inner">
        <BaseText>{{ stockOrder.notes }}</BaseText>
        <BaseMore
          :options="['edit', 'delete']"
          @select="onOptionSelect"
        />
      </div>
    </BaseCard>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import { modal } from '@/helpers/ui';
import CreateNoteModal from '@/modals/CreateNote.vue';
import type { StockOrder } from '@/types';
import useUpdateNote from './updateNote';

const { updateNote } = useUpdateNote();
const props = defineProps<{
  stockOrder: StockOrder;
}>();
const showNoteModal = ref(false);

const { t } = useI18n();

const handleNoteUpdate = (
  notes: string,
  action: 'create' | 'edit' | 'delete',
) => {
  if (props.stockOrder) {
    updateNote(props.stockOrder.id, notes, props.stockOrder.status, action);
    showNoteModal.value = false;
  }
};

const onOptionSelect = (option: string) => {
  if (option === 'edit') {
    showNoteModal.value = true;
  }

  if (option === 'delete') {
    modal('confirmation').then(() => {
      handleNoteUpdate('', 'delete');
    });
  }
};
</script>

<style
  lang="scss"
  module
>
.base {
  margin-bottom: $spacing;
}

.inner {
  display: flex;
  justify-content: space-between;
}
</style>
